// import Vue from "vue";
// import VueRouter from "vue-router";
// Auth
import Locked from "./views/auth/Locked";
import OTPCode from "./views/auth/OTPCode";
import OTPNumber from "./views/auth/OTPNumber";
import Reset from "./views/auth/Reset";
import Signin from "./views/auth/Signin";
import Signup from "./views/auth/Signup";
// Dashboard
import Accounts from "./views/dashboards/Accounts";
import AddBankAccount from "./views/dashboards/AddBankAccount";
import AddDebitCard from "./views/dashboards/AddDebitCard";
import AttCardInfo from "./views/dashboards/AttCardInfo";
import AttBankInfo from "./views/dashboards/AttBankInfo";
import AddCreditCard from "./views/dashboards/AddCreditCard";
import BuySell from "./views/dashboards/BuySell";
import OrderList from "./views/dashboards/Order";
import History from "./views/dashboards/History";
import IDVerified from "./views/dashboards/IDVerified";
import IDVerifying from "./views/dashboards/IDVerifying";
import Index from "./views/dashboards/Index";
import Dashboard from "./views/dashboards/Dashboard";
import Recommendation from "./views/dashboards/Recommendation";
import SelectBankType from "./views/dashboards/SelectBankType";
// Settings
import EditProfile from "./views/dashboards/settings/EditProfile";
import LinkedAccount from "./views/dashboards/settings/LinkedAccount";
import Preferences from "./views/dashboards/settings/Preferences";
import Security from "./views/dashboards/settings/Security";
import AddressWhitelist from "./views/dashboards/settings/AddressWhitelist";
import RecommenKyc from "./views/dashboards/settings/RecommenKyc";
import Success from "./views/dashboards/Success";
import UploadID from "./views/dashboards/UploadID";
import VerifyID from "./views/dashboards/VerifyID";
// Demo
import Demo from "./views/Demo";
import CertPendding from "./views/reg/cert_pendding";
//Reg Person
import userRegStep1 from "./views/reg/person_step_1";
import userRegStep2 from "./views/reg/person_step_2";
import userRegStep3 from "./views/reg/person_step_3";
import userRegStep4 from "./views/reg/person_step_4";
//Reg Company
import companyUserRegStep1 from "./views/reg/inc_person_step_1";
import companyUserRegStep2 from "./views/reg/inc_person_step_2";
import companyUserRegStep3 from "./views/reg/inc_person_step_3";
import companyUserRegStep4 from "./views/reg/inc_person_step_4";
import companyUserRegStep5 from "./views/reg/inc_person_step_5";
import companyUserRegStep6 from "./views/reg/inc_person_step_6";
// Vue.use(VueRouter);
import Signout from "./views/auth/Signout";

import OrderDetail from "./views/dashboards/order/detail";

const routes = [
    // Order
    {
        path: "/order/detail",
        name: "order_detail",
        component: OrderDetail,
    },
    // Reg
    {
        path: "/cert_pendding",
        name: "cert_pendding",
        component: CertPendding,
    },
    {
        path: "/reg/person/step1",
        name: "userRegStep1",
        component: userRegStep1,
    },
    {
        path: "/reg/person/step2",
        name: "userRegStep2",
        component: userRegStep2,
    },
    {
        path: "/reg/person/step3",
        name: "userRegStep3",
        component: userRegStep3,
    },
    {
        path: "/reg/person/step4",
        name: "userRegStep4",
        component: userRegStep4,
    },
    {
        path: "/reg/inc_cert/step1",
        name: "companyUserRegStep1",
        component: companyUserRegStep1,
    },
    {
        path: "/reg/inc_cert/step2",
        name: "companyUserRegStep2",
        component: companyUserRegStep2,
    },
    {
        path: "/reg/inc_cert/step3",
        name: "companyUserRegStep3",
        component: companyUserRegStep3,
    },
    {
        path: "/reg/inc_cert/step4",
        name: "companyUserRegStep4",
        component: companyUserRegStep4,
    },
    {
        path: "/reg/inc_cert/step5",
        name: "companyUserRegStep5",
        component: companyUserRegStep5,
    },
    {
        path: "/reg/inc_cert/step6",
        name: "companyUserRegStep6",
        component: companyUserRegStep6,
    },
    // Demo
    {
        path: "/demo",
        name: "Demo",
        component: Demo,
    },
    // Auth
    {
        path: "/signout",
        name: "signout",
        component: Signout,
    },
    {
        path: "/lock",
        name: "Lock",
        component: Locked,
    },
    {
        path: "/changekyc",
        name: "changeKyc",
        component: RecommenKyc,
    },
    {
        path: "/otp-1",
        name: "OTPNumber",
        component: OTPNumber,
    },
    {
        path: "/signup-validate",
        name: "OTPCode",
        component: OTPCode,
    },
    {
        path: "/signup",
        name: "Signup",
        component: Signup,
    },
    {
        path: "/signin",
        name: "Signin",
        component: Signin,
    },
    {
        path: "/reset",
        name: "Reset",
        component: Reset,
    },
    //Dashboard
    {
        path: "/",
        name: "Index",
        component: Index,
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
    },
    {
        path: "/buy-sell",
        name: "BuySell",
        component: BuySell,
    },
    {
        path: "/order/list",
        name: "OrderList",
        component: OrderList,
    },
    {
        path: "/accounts",
        name: "Accounts",
        component: Accounts,
    },
    {
        path: "/history",
        name: "History",
        component: History,
    },
    {
        path: "/add-bank-acc",
        name: "AddBankAccount",
        component: AddBankAccount,
    },
    {
        path: "/add-debit-card",
        name: "AddDebitCard",
        component: AddDebitCard,
    },
    {
        path: "/att-card-info",
        name: "AttCardInfo",
        component: AttCardInfo,
    },
    {
        path: "/att-bank-address-info",
        name: "AttBankInfo",
        component: AttBankInfo,
    },
    {
        path: "/add-credit-card",
        name: "AddCreditCard",
        component: AddCreditCard,
    },
    {
        path: "/verify-step-1",
        name: "VerifyID",
        component: VerifyID,
    },
    {
        path: "/verify-step-2",
        name: "UploadID",
        component: UploadID,
    },
    {
        path: "/verify-step-3",
        name: "IDVerifying",
        component: IDVerifying,
    },
    {
        path: "/verify-step-4",
        name: "IDVerified",
        component: IDVerified,
    },
    {
        path: "/new_bank_account",
        name: "Recommendation",
        component: Recommendation,
    },
    {
        path: "/select_bank_type",
        name: "SelectBankType",
        component: SelectBankType,
    },
    {
        path: "/verify-step-6",
        name: "Success",
        component: Success,
    },
    // Settings
    {
        path: "/settings-preferences",
        name: "Preferences",
        component: Preferences,
    },
    {
        path: "/addr-whitelist",
        name: "AddressWhitelist",
        component: AddressWhitelist,
    },
    {
        path: "/settings-account",
        name: "LinkedAccount",
        component: LinkedAccount,
    },
    {
        path: "/settings-security",
        name: "Security",
        component: Security,
    },
    {
        path: "/settings",
        name: "EditProfile",
        component: EditProfile,
    },
];

// const router = new VueRouter({
//   mode: "history",
//   // base: process.env.BASE_URL,
//   base: (locale.trim().length && locale != "/") ? '/' + locale : undefined,
//   routes,
// });

export default routes;